import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { Zekvo } from '../models/domain/Zekvo';

@Injectable({
  providedIn: 'root'
})
export class ZekvoService extends BaseService<Zekvo> {
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService) {
    super(http, `${environment.apiUrl}/v1/zekvo`, loadingService);
    this.http = http;
  }

  public generatePdfByZekvoIds(zekvoIds: number[]): Observable<HttpResponse<Blob>> {
    this.loadingService.showLoading();
    return this.http.post(`${this.baseApiUrl}/generatePdfByZekvoIds`, zekvoIds, {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/pdf' },
      observe: 'response'
    }).pipe(
      tap(() => this.loadingService.hideLoading()),
      catchError(error => {
        this.loadingService.hideLoading();
        return throwError(() => error);
      }),
      finalize(() => this.loadingService.hideLoading())
    );
  }
}
